import { TRADE_AREA_GROUP, WAREHOUSE_GROUP } from './constants/officeTypeGroups';
import { getTermsValue, setTerms } from './helpers';
import { TJsonQuery } from './types';
import { EConditionType } from './types/conditionType';
import {
  getLegacyConditionTypeForOffice,
  getLegacyConditionTypeForTradeAreaGroup,
  getLegacyConditionTypeForWarehouseGroup,
} from './utils/getLegacyConditionType';
import { EOfficeType } from '../api-models/common/json_query';

export function setConditionType(jsonQuery: TJsonQuery) {
  return (conditionTypes: EConditionType[] | null): TJsonQuery => {
    const officeType: EOfficeType[] = getTermsValue('office_type')(jsonQuery) ?? [];

    if (!conditionTypes) {
      let next = setTerms('condition_type')(jsonQuery)(null);
      next = setTerms('condition_type__free_appointment_object')(next)(null);
      next = setTerms('condition_type__industry')(next)(null);

      return next;
    }

    const types = conditionTypes;
    const hasOffice = officeType.length === 0 || officeType.includes(EOfficeType.Office);
    const hasTradeArea = officeType.length === 0 || officeType.some(t => TRADE_AREA_GROUP.includes(t));
    const hasWarehouse = officeType.length === 0 || officeType.some(t => WAREHOUSE_GROUP.includes(t));

    let next = jsonQuery;
    next = setTerms('condition_type')(next)(hasOffice ? (getLegacyConditionTypeForOffice(types) ?? null) : null);
    next = setTerms('condition_type__free_appointment_object')(next)(
      hasTradeArea ? (getLegacyConditionTypeForTradeAreaGroup(types, officeType) ?? null) : null,
    );
    next = setTerms('condition_type__industry')(next)(
      hasWarehouse ? (getLegacyConditionTypeForWarehouseGroup(types) ?? null) : null,
    );

    return next;
  };
}
